export enum ClientPatronageStage {
  Unknown = 0,
  Initial = 1,
  Interview = 2,
  Training = 3,
  Photo = 4,
  ResumeFilling = 5,
  ResumeModeration = 6,
  Completed = 7,
  Rejected = 8,
  PersonalQualities = 9,
}

export const CLIENT_PATRONAGE_NON_ACTIVE_STAGES = [ClientPatronageStage.Unknown, ClientPatronageStage.Completed] as const;

export type ClientPatronageActiveStages = Exclude<ClientPatronageStage, (typeof CLIENT_PATRONAGE_NON_ACTIVE_STAGES)[number]>;

/**
 * Logical order of patronage stages. Numeric enum values are not a reliable
 * order because new stages are appended (PersonalQualities = 9).
 * Interview and Rejected are side-paths and are not part of this sequence.
 */
export const CLIENT_PATRONAGE_STAGE_SEQUENCE: ClientPatronageStage[] = [
  ClientPatronageStage.Unknown,
  ClientPatronageStage.Initial,
  ClientPatronageStage.PersonalQualities,
  ClientPatronageStage.Training,
  ClientPatronageStage.Photo,
  ClientPatronageStage.ResumeFilling,
  ClientPatronageStage.ResumeModeration,
  ClientPatronageStage.Completed,
];

export const isClientPatronageStageForward = (from: ClientPatronageStage, to: ClientPatronageStage): boolean => {
  const fromIndex = CLIENT_PATRONAGE_STAGE_SEQUENCE.indexOf(from);
  const toIndex = CLIENT_PATRONAGE_STAGE_SEQUENCE.indexOf(to);
  if (fromIndex === -1 || toIndex === -1) {
    return from < to;
  }
  return fromIndex < toIndex;
};
